export class ReportRepository implements IReportRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }
    async getReports(data: ConsultConditions = {
                columns_select: ["*"],
                where_select: "*"
    }): Promise<Report[]> {
        const response = await this.httpService.post<APIResponse<Report>, ConsultConditions>('/v1/reports/all', { data });
        return response.result.map((report) => ({
            ...report,
            report_id: report.id,
        }));
    }
    async createReport(data: ReportCreateDTO): Promise<number> {
        const response = await this.httpService.post<ReportCreateResponse, ReportCreateDTO>('/v1/reports/add', { data });
        return response.result[0].id;
    }
    async updateReport(data: CustomReportUpdateDTO): Promise<number> {
        const response = await this.httpService.post<APIResponse<null>, CustomReportUpdateDTO>('/v1/reports/update', { data });
        return response.result.length;
    }
    async deleteReport(data: ReporteDeleteDTO): Promise<number> {
        const response = await this.httpService.post<APIResponse<{id:number}>, ReporteDeleteDTO>('/v1/reports/delete', { data });
        return response.result[0].id;
    }
    async executeReport(data: ExecuteReportDTO): Promise<any> {
        const response = await this.httpService.post<APIResponse<any>, ExecuteReportDTO>('/v1/reports/execute', { data });
        return response.result;
    }
}
